module.exports = __webpack_public_path__ + "static/Vijayanath_Bhuvanagiri-ebab028f6b1f2b7e907e432238731ca6.jpg";